module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pedido/pedido.component.html
// module id = ./src/app/pedido/pedido.component.html
// module chunks = main